var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("article", { staticClass: "nti-promotion__best-seller-card" }, [
    _c(
      "a",
      {
        staticClass: "nti-promotion__best-seller-card__link-container",
        attrs: { href: _vm.card.link },
      },
      [
        _c("div", { staticClass: "nti-promotion__best-seller-card__image" }, [
          _c("img", {
            attrs: { src: _vm.card.imageUrl, alt: "product image" },
          }),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "nti-promotion__best-seller-card__left-container" },
          [
            _c(
              "h3",
              { staticClass: "nti-promotion__best-seller-card__title" },
              [_vm._v(_vm._s(_vm.card.title))]
            ),
            _vm._v(" "),
            _c(
              "h3",
              { staticClass: "nti-promotion__best-seller-card__price" },
              [
                _c(
                  "span",
                  {
                    staticClass: "nti-promotion__best-seller-card__small-font",
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.label.fromLabel) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.card.priceText) +
                    "\n            "
                ),
              ]
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }